export const DEFAULT_MAP_SECTION_ORDER = ['Dunwich', 'Arkham', 'Kingsport', 'Innsmouth', 'Other Worlds'] as const;
export type MapSection = typeof DEFAULT_MAP_SECTION_ORDER[number];

export function normalizeMapSectionOrder(value: unknown): MapSection[] {
  const known = Array.isArray(value) ? value.filter((entry): entry is MapSection =>
    DEFAULT_MAP_SECTION_ORDER.includes(entry)) : [];
  return Array.from(new Set([...known, ...DEFAULT_MAP_SECTION_ORDER]));
}
